import { render, staticRenderFns } from "./OperaPlatformGoodsSkuWindow.vue?vue&type=template&id=7a0885d6&scoped=true&"
import script from "./OperaPlatformGoodsSkuWindow.vue?vue&type=script&lang=js&"
export * from "./OperaPlatformGoodsSkuWindow.vue?vue&type=script&lang=js&"
import style0 from "./OperaPlatformGoodsSkuWindow.vue?vue&type=style&index=0&id=7a0885d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a0885d6",
  null
  
)

export default component.exports